import React from 'react';
import DOMPurify from 'dompurify';

/**
 * Class depicting a single article card.
 */
export default class ArticleCard extends React.Component {
    constructor(props) {
        super(props);
    }

    /**
     * Renders the article card item.
     */
    render() { 
        if (!this.props.url) {
            return;
        }
        let imageBlock = [];

        if (this.props.image !== null) {
            imageBlock.push(
                <div className='article__image' key={'article__image'}>
                    <img src={DOMPurify.sanitize(this.props.image.url)} alt={this.props.image.alt}></img>
                </div>
            );
        }
        
        return(
            <a className='c-h-category-related-articles__article article' 
                href={DOMPurify.sanitize(this.props.url)} 
                title={`Read more about ${this.props.title}`}>
                {imageBlock}
                <div className='article__text-wrapper'>
                    <div className='article__read-time-wrapper'>
                        <div className='article__category-name'>
                            {this.props.categoryName}
                        </div>
                        <div className='article__read-time'>
                            {`Read Time: ${this.props.readTime} Min`}
                        </div>
                    </div>
                    <div className='article__title'>
                        {this.props.title}
                    </div>
                    <div className='article__excerpt' dangerouslySetInnerHTML={{__html: `${DOMPurify.sanitize(this.props.excerpt)}`}}>
                    </div>
                    <div className='article__publish-date'>
                        {this.props.publishDate}
                    </div>
                </div>
            </a>
        )
    }
}